const state = {
  purchases: {
    data: [],
  },
  uses: {
    data: [],
  },
};

export default state;
